import React, {Component} from "react";
import {connect} from "react-redux";
import {toast} from "react-toastify";
import {GetCartData, RefreshTable, ViewTable,} from "../../../redux/actions/Cart.Action";
import ApiConnect from "../../../Utils/ApiConnect";

class CartChangeTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tableGroup: true,
      tables: [],
    };
  }
  ViewTable(group) {
    this.props.ViewTable(group);
    this.setState({ tableGroup: false });
  }
  BackToGroup() {
    if (this.props.waiter) {
      this.props.RefreshTable();
    }
    this.setState({ tableGroup: true });
  }
  ChangeTable(toTable, group, target) {
    const opencart = this.props.CurrentCart;
    if (opencart.length !== 0) {
      ApiConnect.put(
        `/POS/Inventory/ChangeTable?orderid=${opencart.order_id}&changeto=${toTable}`
      )
        .then((response) => {
          // console.log(response)
          this.props.GetCartData(toTable, group, target);
          this.props.RefreshTable();
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      toast.error("Please select the table", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        draggableDirection: "y",
      });
    }
  }
  render() {
    const tableData = this.props.CartTableGroup || [];
    const tables = this.props.CartTables || [];
    return (
      <div className="justify-content-center text-center">
        <ul className="waiter-table">
          {this.state.tableGroup ? (
            tableData.map((tableData, index) => (
              <li
                className="bg-purple tex-center"
                key={index}
                onClick={() => this.ViewTable(tableData.id)}
              >
                <div className="row">
                  <div className="col">
                    <span className="title"> {tableData.name}</span>
                  </div>
                  <div className="col">
                    <span className="subtitle">
                      {
                        tableData.tables.filter((tables) => tables.status === 1)
                          .length
                      }{" "}
                      Open
                    </span>
                  </div>
                </div>
              </li>
            ))
          ) : (
            <>
              <li
                className="bg-cyan"
                onClick={() => {
                  this.BackToGroup();
                }}
              >
                <div className="text-center">
                  <span className="material-icons-outlined fs-40 p-0">
                    undo
                  </span>
                </div>

                <div className="d-flex align-items-end justify-content-center">
                  <span className="subtitle">Back</span>
                </div>
              </li>
              {tables.map((table, index) => (
                <React.Fragment key={index}>
                  {table.current === 1 ? (
                    <li className="active" key={index}>
                      <div className="d-flex align-items-start justify-content-between">
                        <span className="material-icons-outlined">people</span>
                        <span className="title"> {table.table}</span>
                      </div>

                      <div className="d-flex align-items-center">
                        <span className="subtitle">RS.{table.total}</span>
                      </div>
                      <div className="d-flex align-items-end justify-content-between">
                        <p>{table.guest} People</p>
                      </div>
                    </li>
                  ) : table.status === 0 ? (
                    <li
                      className="bg-pink"
                      onClick={(e) =>
                        this.ChangeTable(table.table, table.groupid, e.target)
                      }
                      key={index}
                    >
                      <div className="d-flex align-items-start justify-content-between">
                        <span className="material-icons-outlined">people</span>
                        <span className="title"> {table.table}</span>
                      </div>

                      <div className="text-center">
                        <span className="material-icons-outlined fs-40 p-0">
                          transfer_within_a_station
                        </span>
                      </div>
                    </li>
                  ) : (
                    ""
                  )}
                </React.Fragment>
              ))}
            </>
          )}
        </ul>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    CartTableGroup: state.Cart.Table.group,
    CartTables: state.Cart.Table.table,
    CurrentCart: state.Cart.CurrentCart,
  }),
  { GetCartData, ViewTable, RefreshTable }
)(React.memo(CartChangeTable));
